import React, { useEffect, useState } from "react";
import { Table, Empty, Row, Col, Divider } from "antd";
import { BarsOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "../../util/TableHelper";
import { useMediaQuery } from "react-responsive";
import { odata, queryHelper } from "../../routes/Filters/Helper/index";

const FirmTrackingTransactionDetailA = (props) => {
  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );

  useEffect(() => {
    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.post(
      `/FirmTracking/GetTransactionById`,
      {
        transactionId:
          props.transactionId != "null"
            ? props.transactionId
            : "00000000-0000-0000-0000-000000000000",
        planId:
          props.planId != "null"
            ? props.planId
            : "00000000-0000-0000-0000-000000000000",
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        setTableData({
          data: res.data,
          total: 1,
          loading: false,
        });
      } else {
        setTableData({
          data: [],
          total: 0,
          loading: false,
        });
      }
    });
  }, []);

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDateValue",
      key: "transactionDateValue",
      align: "left",
      render: (data) => moment(data).format("L"),
    },
    {
      title: "İşlem Tipi",
      dataIndex: "processTypeName",
      key: "processTypeName",
      align: "left",
      render: (text) => {
        if (text === "Satış Faturası") {
          return "Alış Faturası";
        } else if (text === "Alış Faturası") {
          return "Satış Faturası";
        } else {
          return text;
        }
      },
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      key: "amountString",
      align: "left",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
    },
  ];

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  return (
    <div>
      <Row id="titleArea">
        <Col xs={24} md={12} lg={16}>
          <h1 style={{ marginBottom: 0 }}>
            <BarsOutlined /> İşlem Detayı
          </h1>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}></Col>
      </Row>
      <Divider style={{ margin: "12px 0" }} />
      <Row>
        <>
          <Col span={24}>
            <Table
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{
                overflowX: "auto",
                maxHeight: "100%",
                width: "100%",
              }}
              columns={columns}
              onDataStateChange={dataStateChange}
              dataSource={tableData.data}
              loading={tableData.loading}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              sortable={true}
              rowKey="id"
            ></Table>
          </Col>
        </>
      </Row>
    </div>
  );
};

export default FirmTrackingTransactionDetailA;
